<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
            <a-col :span="12">
              <a-form-item :label="$t('label.changeRange')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag  type="list" v-decorator="['changeScope', validatorRules.changeScope]" @change="changeScopeChange" :trigger-change="true" dictCode="change_type" placeholder="请选择变更范围"/>
              </a-form-item>
              <!--<a-form-item label="变更范围" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-radio-group v-decorator="['changeScope', validatorRules.changeScope]" @change="changeScopeChange">
                  <a-radio value="10">公司</a-radio>
                  <a-radio value="20">合同</a-radio>
                  <a-radio value="30">服务部</a-radio>
                </a-radio-group>
                &lt;!&ndash; <a-input v-decorator="['defaultFlag']" placeholder="请输入默认版本"></a-input>&ndash;&gt;
              </a-form-item>-->
            </a-col>

          <a-col :span="12" v-show="conCodeStatus">
            <a-form-item :label="$t('label.contractID')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectContractID')" option-label-prop="label" showSearch option-filter-prop="children"    v-decorator="[
                 'conCode',
                   form.getFieldsValue(['changeScope']).changeScope == 20 ? validatorRules.conCode : {}
                ]">
                <a-select-option
                  v-for="item in conCodeList"
                  :key="item.code"
                  :label="item.code"
                  :value="item.code">
                  {{ item.code+"|"+item.name }}
                </a-select-option>
              </a-select>

            </a-form-item>
          </a-col>


          <a-col :span="12" v-show="serviceDepartmentStatus">
            <a-form-item :label="$t('label.serviceDepartment')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectServiceDepartmentOrFarm')"  showSearch option-filter-prop="children"    v-decorator="[
                 'serviceDepartment',
                   form.getFieldsValue(['changeScope']).changeScope == 30 ? validatorRules.serviceDepartment : {}
                ]">
                <a-select-option
                  v-for="item in serviceDepartmentList"
                  :key="item.orgCode"
                  :value="item.orgCode">
                  {{ item.departName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :span="12">
            <a-form-item :label="$t('label.materialNumber')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectTheMaterialNo')" option-label-prop="label" showSearch option-filter-prop="children"     v-decorator="['mmCode', validatorRules.mmCode]" @change="mmCodeChanged">
                <a-select-option
                  v-for="item in mmCodeList"
                  :key="item.code"
                  :label="item.code"
                  :value="item.code">
                  {{ item.code+"|"+item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :span="12">
            <a-form-item :label="$t('label.materialName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="true" v-decorator="['mmName',validatorRules.mmName]" :placeholder="$t('label.pleaseEnterTheName')"  ></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('label.materialCategory')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag :disabled="isMmCategoryDisabled" v-decorator="['mmCategoryCode']"
                                   dict="efs_md_mm_group,name,code"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.unitPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['unitPrice', validatorRules.unitPrice]" :placeholder="$t('label.pleaseEnterTheUnitPrice')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.effectiveTime')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectEffectiveTime')" v-decorator="['startTime', validatorRules.startTime]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import JSearchSelectTagOptionIsValueText from '@/components/dict/JSearchSelectTagOptionIsValueText'

  export default {
    name: 'EfsMdContractPriceChangeForm',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
      JSearchSelectTag,
      JSearchSelectTagOptionIsValueText
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
            serviceDepartment: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectTheServiceDepartment')},
                ]
            },
            conCode: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectContract')},
                ]
            },
            changeScope: {
                rules: [
                    { required: true, message: '请选择变更范围!'},
                ]
            },
          mmCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectTheMaterialNo')},
            ]
          },
          mmCategoryCode: {
            rules: [
              { required: true, message: '请输入物料类别!'},
            ]
          },
          unitPrice: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheUnitPrice')},
              { pattern: /^\d+(.\d+)?$/, message: '请输入正确的金额!'},
            ]
          },
          startTime: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectEffectiveTime')},
            ]
          },
          endTime: {
            rules: [
              { required: true, message: '请输入失效时间!'},
            ]
          },
        },
        url: {
          add: "/priceChange/efsMdContractPriceChange/add",
          edit: "/priceChange/efsMdContractPriceChange/edit",
          queryById: "/priceChange/efsMdContractPriceChange/queryById",
          queryByMmCode: '/priceList/groupPriceList/efsMdGroupPriceList/queryByCodeNew',
          queryByconCodeAndmmCode: '/priceList/groupPriceList/efsMdGroupPriceList/queryByconCodeAndmmCode'
        },
        isMmCodeDisabled: false,
        isMmCategoryDisabled: true,
        isEndTimeDisabled: true,
        conCodeStatus:false,
        serviceDepartmentStatus:false,
        conCodeList:[],
        serviceDepartmentList:[],
        mmCodeList:[],
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'mmCode','mmCategoryCode','unitPrice','startTime','endTime','approvalStatus','isMmValid','changeScope','conCode','mmName'))
        })
          if(this.model.changeScope=="10"){
              this.conCodeStatus=false;
              this.serviceDepartmentStatus=false;
          }else if(this.model.changeScope=="20"){
              this.conCodeStatus=true;
              this.serviceDepartmentStatus=false;
          }else if(this.model.changeScope=="30"){
              this.conCodeStatus=false;
              this.serviceDepartmentStatus=true;
          }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'mmCode','mmCategoryCode','unitPrice','startTime','endTime','approvalStatus','isMmValid','changeScope','conCode','mmName'))
      },
      mmCodeChanged(param) {
        getAction(this.url.queryByMmCode, { code: param }).then(res => {
          if (res.success) {
            this.form.setFieldsValue({
              mmCode: res.result.code,
              mmCategoryCode: res.result.mmGrpCode,
              mmName: res.result.name
            })
          } else {
            this.$message.warning(res.message)
          }
        })
      },
        changeScopeChange(changeScope){
          if(changeScope=="10"){
              this.serviceDepartmentStatus=false;
              this.conCodeStatus=false;
              this.form.setFieldsValue({
                  conCode: "",
                  serviceDepartment:"",
              })
          }else if(changeScope=="20"){
              this.serviceDepartmentStatus=false;
              this.conCodeStatus=true;
          }else if(changeScope=="30"){
              this.serviceDepartmentStatus=true;
              this.conCodeStatus=false;
        }
            getAction(this.url.queryByconCodeAndmmCode).then(res => {
                if (res.success) {
                    this.conCodeList=res.result.efsMdContractList;
                    this.mmCodeList=res.result.efsMdMaterialList;
                    this.serviceDepartmentList=res.result.sysDepartList;
                } else {
                    this.$message.warning(res.message)
                }
            })
        }
    }
  }
</script>